export const getCurrency = (number, curr) => {
    if (number >= 0 && curr) {
        return new Intl.NumberFormat("ru-RU", {
            maximumSignificantDigits: 3,
            style: "currency",
            currency: curr,
        }).format(number);
    } else if (number) {
        return new Intl.NumberFormat("ru-RU", {
            maximumSignificantDigits: 3,
        }).format(number);
    } else {
        return null;
    }
};

export const getInputMask = (value) => {
    if (!value) {
        return "";
    }

    let stringValue = String(value);

    let step = 3;

    if (step >= stringValue.length) {
        return stringValue;
    }

    let str = stringValue.substring(0, stringValue.length % 3);
    let strArray = stringValue.substring(stringValue.length % 3, stringValue.length).split("");

    strArray.forEach((el, index) => {
        if (index % 3 === 0) {
            str += " " + el;
        } else {
            str += el;
        }
    });

    return str.trim();
};
